module.exports = __webpack_public_path__ + "assets/infoIcon-0a0245.svg";